<template>

    <div class="panel-head-section">
        <div>
            <div>
                <h1>My selected workouts</h1>
                <small>Click to place</small>
            </div>
        </div>
    </div>

    <div class="pending-list">

        <p v-if="$store.getters.getMainData?.user_data.library_favorites.length">You can <a href="/quiz">retake the quiz</a> at any time to automatically create a new personalised library and schedule!</p>

        <ul>
            <li
                v-for="vid in $store.getters.getPrivateLibrary"
                :class="{
                    active: $store.getters.getCalendarVideoBeingPlaced.vimeo_id === vid.vimeo_id,
                    placed: $store.getters.placedVimeoIdsList.includes(vid.vimeo_id),
                    disabled: $store.getters.isPlacementModeActive && $store.getters.getCalendarVideoBeingPlaced.vimeo_id !== vid.vimeo_id
                }"
                @click="togglePlaceVid(vid)"
            >
                <span>{{ vid.video_data.title }}</span>
    <!--            <ul>-->
    <!--                <li v-for="prop in vid.video_data.props" class="prop-label" :class="prop"></li>-->
    <!--            </ul>-->
                <a class="place-vid-btn"></a>
            </li>
        </ul>

    </div>

    <p v-if="$store.getters.getMainData?.user_data.library_favorites.length === 0">You haven't added any favourites yet; to help you get started,
        <a href="/quiz">take the quick quiz</a> to create a personalized library and workout schedule!</p>

</template>

<script>

export default {

	data(){
		return {

        }
    },
    mounted(){

    },
    methods: {
        togglePlaceVid(data)
        {
        	if(this.$store.getters.isPlacementModeActive)
            {
                this.$store.commit('resetVideoPlacement');
                return false;
            }

        	this.$store.dispatch('placingVideo', data);

            if(!this.$store.getters.isDesktopScreen)
            {
                $("html, body").animate({ scrollTop: 0 });
            }
        }
    }

}

</script>
